import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import CommonTextField from "../commonTextField/CommonTextField";
import CommonDropdown from "../commonDropDown/CommonDropDown";
import FlexibleTextarea from "../textArea/FlexibleTextarea";
import FileUploader from "../SimpleFileDropper/FileUploader";
import { useState } from "react";
import { FaLinkedin } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";
import Earth from "../../images/svgs/Earth";
import CustomButton from "../customButtom/CustomButton";
import TextInputIcon from "../Inputs/TextInputIcon";
import ApplicationSuccess from "../applicationSuccess/ApplicationSuccess";
import CertificationUpload from "../certifications/CertificationUpload";
import { editProfile, getProfile } from "../../services/mentorProfile";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import Papa from "papaparse";
import {
  ageGroup,
  AILiteracySkills,
  appliedAISkills,
  AutoMLNoCodeLowCodeAIPlatforms,
  BusinessStrategyDesignRoles,
  CommunicationSkills,
  Compliance,
  ComputerVisionTools,
  CreativeInterdisciplinaryRoles,
  CriticalThinkingProblemSolving,
  DataScienceVisualizationTools,
  education,
  EmergingAI,
  EthicsSafetyGovernanceRoles,
  experience,
  GenerativeAITools,
  industries,
  InfrastructureMLOpsRoles,
  InterpersonalTeamworkSkills,
  LeadershipInfluence,
  MachineLearningDeepLearningPlatforms,
  MLOpsDeploymentTools,
  NaturalLanguageProcessingTools,
  race,
  ResponsibleAI,
  selectYesNO,
  SelfManagementSkills,
  softAISkills,
  status,
  strategicAISkills,
  technicalAISkills,
  TechnicalDevelopmentRoles,
  technologies,
  workYears,
} from "../../constants/constants";
import { useParams } from "react-router-dom";
import MultiSelectDropDown from "../multiSelect/MultiSelect";

const schema = yup.object().shape({
  firstName: yup.string().required("First Name is required").default(""),
  lastName: yup.string().required("Last Name is required"),
  gender: yup.number().required("Gender is required"),
  country: yup.string().required("Country is required"),
  state: yup.string().required("State / Province is required"),
  city: yup.string().required("City is required"),
  ageGroup: yup.string().required("Age is required"),
  race: yup.string().required("Race is required"),
  email: yup.string().required("Email is required").email("Enter a valid email"),
  bio: yup.string().required("Bio is required"),
  education: yup.string().required("Education Level is required"),
  employmentStatus: yup.string().required("Employment Status is required"),
  professionalExperience: yup
    .string()
    .required("Professional Experience is required"),
  yearsOfExperience: yup.string().required("Years of experience is required"),
  jobTitle: yup.string().required("Current Job Title is required"),
  industry: yup.string().required("Industry is required"),

  mentoringExperience: yup.string(),
  yearsOfMentoring: yup.string().required("Years of Mentoring Experience is required"),
  mentorReason: yup
    .string()
    .required("Why do you want to be a mentor? is required"),
  mentorExperiance: yup.string().required("Professional experience required"),

  general: yup.array().of(yup.string()).nullable(),
  AILiteracySkills: yup.array().of(yup.string()).nullable(),
  appliedAISkills: yup.array().of(yup.string()).nullable(),
  ethicsResponsibleAI: yup.array().of(yup.string()).nullable(),
  softAISkills: yup.array().of(yup.string()).nullable(),
  strategicAISkills: yup.array().of(yup.string()).nullable(),
  technicalAISkills: yup.array().of(yup.string()).nullable(),
  TechnicalDevelopmentRoles: yup.array().of(yup.string()).nullable(),
  InfrastureRoles: yup.array().of(yup.string()).nullable(),
  ethicsRoles: yup.array().of(yup.string()).nullable(),
  buisnessRole: yup.array().of(yup.string()).nullable(),
  CreativeRole: yup.array().of(yup.string()).nullable(),
  Compliance: yup.array().of(yup.string()).nullable(),
  EmergingAI: yup.array().of(yup.string()).nullable(),
  MachineLearningDeepLearningPlatforms: yup.array().of(yup.string()).nullable(),
  AutoMLNoCodeLowCodeAIPlatforms: yup.array().of(yup.string()).nullable(),
  NaturalLanguageProcessingTools: yup.array().of(yup.string()).nullable(),
  ComputerVisionTools: yup.array().of(yup.string()).nullable(),
  GenerativeAITools: yup.array().of(yup.string()).nullable(),
  MLOpsDeploymentTools: yup.array().of(yup.string()).nullable(),
  DataScienceVisualizationTools: yup.array().of(yup.string()).nullable(),
  CommunicationSkills: yup.array().of(yup.string()).nullable(),
  InterpersonalTeamworkSkills: yup.array().of(yup.string()).nullable(),
  CriticalThinkingProblemSolving: yup.array().of(yup.string()).nullable(),
  SelfManagementSkills: yup.array().of(yup.string()).nullable(),
  LeadershipInfluence: yup.array().of(yup.string()).nullable(),
  ai_application: yup.array().of(yup.string()).nullable(),
  technology: yup.string(),
  openToFacilitating: yup.string().oneOf(["yes", "no"]),
  openToConsulting: yup.string().oneOf(["yes", "no"]),
  openToGroup: yup.string().oneOf(["yes", "no"]),
  openToVolunteer: yup.string().oneOf(["yes", "no"]),
  maximumNumbers: yup.string().when("openToVolunteer", {
    is: (val) => val === "yes", // ← ensure this is a function returning a boolean
    then: () =>
      yup
        .string()
        .required("Please select maximum number of sessions")
        .matches(/^(10|[1-9])$/, "Must be a number between 1 and 10"),
    otherwise: () => yup.string().notRequired(),
  }),
  volunteerMins: yup.string().when("openToVolunteer", {
    is: (val) => val === "yes", // ← ensure this is a function returning a boolean
    then: () => yup.string().required("Please select Volunteer Mins"),
    otherwise: () => yup.string().notRequired(),
  }),
  pricePerMentee: yup.string().when("openToGroup", {
    is: (val) => val === "yes", // ← ensure this is a function returning a boolean
    then: () => yup.string().required().matches(/^\d+$/, "Must be a number"),
    otherwise: () => yup.string().notRequired(),
  }),
  minSession: yup.string().when("openToGroup", {
    is: (val) => val === "yes", // ← ensure this is a function returning a boolean
    then: () => yup.string().required(),
    otherwise: () => yup.string().notRequired(),
  }),
  photo: yup
    .mixed()
    .test(
      "fileTypeOrString",
      "Only image files or a valid URL are allowed",
      (value) => {
        if (typeof value === "string") {
          return /^https?:\/\/.*\.(jpeg|jpg|png)$/i.test(value); // Validate image URL
        }
        return value && ["image/jpeg", "image/png"].includes(value?.type);
      }
    )
    .required("Photo is required"),

  cv: yup
    .mixed()
    .test("fileTypeOrString", "Only document files", (value) => {
      if (typeof value === "string") {
        return /^https?:\/\/.*\.(pdf|doc|docx)$/i.test(value); // Validate document URLs
      }
      return (
        value &&
        [
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ].includes(value?.type)
      );
    })
    .required("CV is required"),

  linkedIn: yup
    .string()
    .matches(
      /^(https?:\/\/)?(www\.)?linkedin\.com\/(in|company)\/[a-zA-Z0-9_-]+\/?$/,
      "Invalid LinkedIn URL"
    )
    .required("URL is required"),
  twitter: yup.string().url("Must be a valid URL").notRequired(),
  personalWebsite: yup.string().url("Invalid URL").notRequired(),

  CertificationName: yup.string().nullable(),
  provider: yup.string().nullable(),
  description: yup.string().nullable(),
  issueDate: yup.string().nullable(),
  expirationDate: yup.string().nullable(),
  certificationID: yup.string().nullable(),
  certificationURL: yup.string().nullable(),
});

const MentorProfileForm = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const mentorProfile = useSelector((state) => state.mentor.profile);
  const isProfileComplete = useSelector(
    (state) => state.auth.isProfileComplete
  );
  const [options, setOptions] = useState([]);
  const [isLoadingIndustries, setIsLoadingIndustries] = useState(true);
  const [industryData, setIndustryData] = useState([]);

  const dispatch = useDispatch();
  const [showPopup, setShowPopup] = useState(false);
  // const [data, setData] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [data, setData] = useState(false);

  useEffect(() => {
    dispatch(getProfile({ userId: "" }));
  }, [dispatch]);
  const {
    register,
    watch,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onSubmit",
    defaultValues: {
      email: mentorProfile?.email,
      firstName: mentorProfile?.firstName,
      lastName: mentorProfile?.lastName,
      gender: mentorProfile?.gender,
      country: mentorProfile?.country,
      state: mentorProfile?.state,
      city: mentorProfile?.city,
      ageGroup: mentorProfile?.ageGroup,
      race: mentorProfile?.race,
      bio: mentorProfile?.bio,

      education: mentorProfile?.higherEducationLevel,
      employmentStatus: mentorProfile?.employmentStatus,
      professionalExperience: mentorProfile?.professionalExperience,
      yearOfExperience: mentorProfile?.yearsOfExperience,
      jobTitle: mentorProfile?.currentJobOccupation,
      industry: mentorProfile?.industry,

      mentoringExperience: mentorProfile?.formalMentoringOrCoachingExperience,
      yearsOfMentoring: mentorProfile?.yearsOfMentoring,
      whyDoYouWantToBeMentor: mentorProfile?.mentorReason,
      mentorExperiance: mentorProfile?.mentorExperiance,

      general: mentorProfile?.general,
      AILiteracySkills: mentorProfile?.AILiteracySkills,
      appliedAISkills: mentorProfile?.appliedAISkills,
      ethicsResponsibleAI: mentorProfile?.ethicsResponsibleAI,
      softAISkills: mentorProfile?.softAISkills,
      strategicAISkills: mentorProfile?.strategicAISkills,
      technicalAISkills: mentorProfile?.technicalAISkills,
      TechnicalDevelopmentRoles: mentorProfile?.TechnicalDevelopmentRoles,
      InfrastureRoles: mentorProfile?.InfrastureRoles,
      ethicsRoles: mentorProfile?.ethicsRoles,
      buisnessRole: mentorProfile?.buisnessRole,
      CreativeRole: mentorProfile?.CreativeRole,
      Compliance: mentorProfile?.Compliance,
      EmergingAI: mentorProfile?.EmergingAI,
      MachineLearningDeepLearningPlatforms:
        mentorProfile?.MachineLearningDeepLearningPlatforms,
      AutoMLNoCodeLowCodeAIPlatforms:
        mentorProfile?.AutoMLNoCodeLowCodeAIPlatforms,
      NaturalLanguageProcessingTools:
        mentorProfile?.NaturalLanguageProcessingTools,
      ComputerVisionTools: mentorProfile?.ComputerVisionTools,
      GenerativeAITools: mentorProfile?.GenerativeAITools,
      MLOpsDeploymentTools: mentorProfile?.MLOpsDeploymentTools,
      DataScienceVisualizationTools:
        mentorProfile?.DataScienceVisualizationTools,
      CommunicationSkills: mentorProfile?.CommunicationSkills,
      InterpersonalTeamworkSkills: mentorProfile?.InterpersonalTeamworkSkills,
      CriticalThinkingProblemSolving:
        mentorProfile?.CriticalThinkingProblemSolving,
      SelfManagementSkills: mentorProfile?.SelfManagementSkills,
      LeadershipInfluence: mentorProfile?.LeadershipInfluence,
      ai_application: mentorProfile?.ai_application,
      technology: mentorProfile?.technology,

      openToFacilitating: mentorProfile?.openToFacilitating || "no",
      openToConsulting: mentorProfile?.openToConsulting || "no",
      openToGroup: mentorProfile?.openToGroup || "no",
      minSession: mentorProfile?.minSession,
      pricePerMentee: mentorProfile?.pricePerMentee,
      openToVolunteer: mentorProfile?.openToVolunteer,
      volunteerMins: mentorProfile?.volunteerMins,
      maximumNumbers: mentorProfile?.maximumNumbers,
      linkedIn: mentorProfile?.linkedIn,
      twitter: mentorProfile?.twitter == null ? null : "",
      personalWebsite: mentorProfile?.personalWebsite == null ? null : "",
      CertificationName: mentorProfile?.certificationName || "",
      provider: mentorProfile?.certificationProvider,
      description: mentorProfile?.certificationDescription,
      issueDate: mentorProfile?.certificationIssueDate,
      expirationDate: mentorProfile?.certificationExpiryDate,
      certificationID: mentorProfile?.certificationId,
      certificationUrl: mentorProfile?.certificationUrl,
      photo: mentorProfile?.profileImage,
      cv: mentorProfile?.cv,
    },
  });
  const togglePopup = (data) => {
    setData(data);
    setShowPopup(true);
  };
  const onSubmit = async () => {
    setLoading(true);
    try {
      if (isChecked) {
        // Actual submit logic here
        const response = await dispatch(
          editProfile({
            email: data.email,
            firstName: data.firstName,
            lastName: data.lastName,
            gender: data.gender,
            country: data.country,
            state: data?.state,
            city: data.city,
            ageGroup: data.ageGroup,
            race: data.race,
            bio: data.bio,

            higherEducationLevel: data.education,
            employmentStatus: data.employmentStatus,
            professionalExperience: data.professionalExperience,
            yearOfExperience: data.yearsOfExperience,
            currentJobOccupation: data.jobTitle,

            formalMentoringOrCoachingExperience: data.mentoringExperience,
            yearsOfMentoring: data.yearsOfMentoring,
            whyDoYouWantToBeMentor: data.mentorReason,
            mentorExperiance: data.mentorExperiance,

            industry: data.industry,
            general: data.general,
            AILiteracySkills: data?.AILiteracySkills,
            appliedAISkills: data?.appliedAISkills,
            ethicsResponsibleAI: data?.ethicsResponsibleAI,
            softAISkills: data?.softAISkills,
            strategicAISkills: data?.strategicAISkills,
            technicalAISkills: data?.technicalAISkills,
            TechnicalDevelopmentRoles: data?.TechnicalDevelopmentRoles,
            InfrastureRoles: data?.InfrastureRoles,
            ethicsRoles: data?.ethicsRoles,
            buisnessRole: data?.buisnessRole,
            CreativeRole: data?.CreativeRole,
            Compliance: data?.Compliance,
            EmergingAI: data?.EmergingAI,
            MachineLearningDeepLearningPlatforms:
              data?.MachineLearningDeepLearningPlatforms,
            AutoMLNoCodeLowCodeAIPlatforms:
              data?.AutoMLNoCodeLowCodeAIPlatforms,
            NaturalLanguageProcessingTools:
              data?.NaturalLanguageProcessingTools,
            ComputerVisionTools: data?.ComputerVisionTools,
            GenerativeAITools: data?.GenerativeAITools,
            MLOpsDeploymentTools: data?.MLOpsDeploymentTools,
            DataScienceVisualizationTools: data?.DataScienceVisualizationTools,
            CommunicationSkills: data?.CommunicationSkills,
            InterpersonalTeamworkSkills: data?.InterpersonalTeamworkSkills,
            CriticalThinkingProblemSolving:
              data?.CriticalThinkingProblemSolving,
            SelfManagementSkills: data?.SelfManagementSkills,
            LeadershipInfluence: data?.LeadershipInfluence,
            ai_application: data.ai_application,
            technology: data.technology,

            openToFacilitating: data?.openToFacilitating,
            openToConsulting: data?.openToConsulting,
            openToGroup: data?.openToGroup,
            minSession: data?.minSession,
            pricePerMentee: data.pricePerMentee,
            openToVolunteer: data.openToVolunteer,
            volunteerMins: data?.volunteerMins,
            maximumNumbers: data?.maximumNumbers,

            profileImage: data.photo,
            cv: data.cv,
            linkedIn: data.linkedIn,
            twitter: data.twitter,
            personalWebsite: data.personalWebsite,

            certificationName: data.CertificationName,
            certificationProvider: data.provider,
            certificationDescription: data.description,
            certificationIssueDate: data.issueDate,
            certificationExpiryDate: data.expirationDate,
            certificationId: data.certificationID,
            certificationUrl: data.certificationURL,
          })
        );

        // Show toast only after API response
        if (response && response.success) {
          id
            ? toast.success("Profile Updated")
            : toast.success("Application Submitted");
          setShowPopup(false);
          setIsChecked(false);
        } else if (response && !response.success) {
          // Handle validation errors from backend
          const errorMessage = Array.isArray(response.data) 
            ? response.data.join(", ") 
            : response.data || "Failed to update profile.";
          toast.error(errorMessage);
        }
      }
    } catch (error) {
      console.error("API Error:", error);
      // Handle API errors
      const errorMessage = error?.response?.data?.data 
        ? (Array.isArray(error.response.data.data) 
            ? error.response.data.data.join(", ") 
            : error.response.data.data)
        : error?.response?.data?.message || "Failed to update profile.";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (mentorProfile) {
      reset({
        isVerified: mentorProfile.isVerified,
        email: mentorProfile.email,
        firstName: mentorProfile.firstName,
        lastName: mentorProfile.lastName,
        gender: mentorProfile.gender,
        country: mentorProfile.country,
        state: mentorProfile.state,
        city: mentorProfile.city,
        ageGroup: mentorProfile.ageGroup,
        race: mentorProfile.race,
        bio: mentorProfile.bio,
        education: mentorProfile.higherEducationLevel,
        employmentStatus: mentorProfile.employmentStatus,
        professionalExperience: mentorProfile.professionalExperience,
        yearOfExperience: mentorProfile.yearsOfExperience,
        jobTitle: mentorProfile.currentJobOccupation,
        mentoringExperience: mentorProfile.formalMentoringOrCoachingExperience,
        yearsOfMentoring: mentorProfile.yearsOfMentoring,
        whyDoYouWantToBeMentor: mentorProfile.mentorReason,
        mentorExperiance: mentorProfile.mentorExperiance,
        industry: mentorProfile.industry,
        general: mentorProfile.general,
        AILiteracySkills: mentorProfile?.AILiteracySkills,
        appliedAISkills: mentorProfile?.appliedAISkills,
        ethicsResponsibleAI: mentorProfile?.ethicsResponsibleAI,
        softAISkills: mentorProfile?.softAISkills,
        strategicAISkills: mentorProfile?.strategicAISkills,
        technicalAISkills: mentorProfile?.technicalAISkills,
        TechnicalDevelopmentRoles: mentorProfile?.TechnicalDevelopmentRoles,
        InfrastureRoles: mentorProfile?.InfrastureRoles,
        ethicsRoles: mentorProfile?.ethicsRoles,
        buisnessRole: mentorProfile?.buisnessRole,
        CreativeRole: mentorProfile?.CreativeRole,
        Compliance: mentorProfile?.Compliance,
        EmergingAI: mentorProfile?.EmergingAI,
        MachineLearningDeepLearningPlatforms:
          mentorProfile?.MachineLearningDeepLearningPlatforms,
        AutoMLNoCodeLowCodeAIPlatforms:
          mentorProfile?.AutoMLNoCodeLowCodeAIPlatforms,
        NaturalLanguageProcessingTools:
          mentorProfile?.NaturalLanguageProcessingTools,
        ComputerVisionTools: mentorProfile?.ComputerVisionTools,
        GenerativeAITools: mentorProfile?.GenerativeAITools,
        MLOpsDeploymentTools: mentorProfile?.MLOpsDeploymentTools,
        DataScienceVisualizationTools:
          mentorProfile?.DataScienceVisualizationTools,
        CommunicationSkills: mentorProfile?.CommunicationSkills,
        InterpersonalTeamworkSkills: mentorProfile?.InterpersonalTeamworkSkills,
        CriticalThinkingProblemSolving:
          mentorProfile?.CriticalThinkingProblemSolving,
        SelfManagementSkills: mentorProfile?.SelfManagementSkills,
        LeadershipInfluence: mentorProfile?.LeadershipInfluence,
        ai_application: mentorProfile.ai_application,
        technology: mentorProfile.technology,
        openToFacilitating: mentorProfile?.openToFacilitating,
        openToConsulting: mentorProfile?.openToConsulting,
        openToGroup: mentorProfile?.openToGroup,
        minSession: mentorProfile?.minSession,
        pricePerMentee: mentorProfile?.pricePerMentee,
        openToVolunteer: mentorProfile?.openToVolunteer,
        volunteerMins: mentorProfile?.volunteerMins,
        maximumNumbers: mentorProfile?.maximumNumbers,
        linkedIn: mentorProfile.linkedIn,
        twitter:
          mentorProfile.twitter === "null" ? null : mentorProfile.twitter,
        personalWebsite:
          mentorProfile.personalWebsite === "null"
            ? null
            : mentorProfile.personalWebsite,
        CertificationName: mentorProfile.certificationName || "",
        provider: mentorProfile.certificationProvider || "",
        description: mentorProfile.certificationDescription || "",
        issueDate: mentorProfile.certificationIssueDate || "",
        expirationDate: mentorProfile.certificationExpiryDate || "",
        certificationID: mentorProfile.certificationId || "",
        certificationUrl: mentorProfile.certificationUrl || "",
        photo: mentorProfile.profileImage || "",
        cv: mentorProfile.cv || "",
      });
    }
  }, [mentorProfile, reset]);

  const openToVolunteer = watch("openToVolunteer");
  const openToGroup = watch("openToGroup");

  useEffect(() => {
    const csvFilePath = "/output.csv"; // Ensure the CSV is placed in the 'public' folder

    fetch(csvFilePath)
      .then((response) => response.text())
      .then((csvText) => {
        Papa.parse(csvText, {
          header: true,
          skipEmptyLines: true,
          complete: (result) => {
            const formattedOptions = result.data.map((row) => ({
              value: row.name,
              label: row.name,
            }));
            setOptions(formattedOptions);
            // setTargetJobOptions(formattedOptions);
          },
        });
      })
      .catch((error) => console.error("Error fetching CSV:", error));
  }, []);

  useEffect(() => {
    (async () => {
      try {
        setIsLoadingIndustries(true);
        const response = await fetch("/unique_industries_ascending.csv");
        const parsed = Papa.parse(await response.text(), { header: true }).data;
        const formattedData = parsed.filter(r => r["Industry Title"]?.trim()).map(r => ({
          value: r["Industry Title"], 
          label: r["Industry Title"]
        }));
        
        setIndustryData(formattedData);
      } catch (err) {
        console.error("Error loading industries:", err);
      } finally {
        setIsLoadingIndustries(false);
      }
    })();
  }, []);
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${today.getFullYear()}`;

  return (
    <>
      {!isProfileComplete || id ? (
        <>
          <div className="text-xl text-custom-pink font-bold my-4">
            Mentorship Application Form
          </div>
          <div className="w-full mx-auto bg-white shadow-lg rounded-lg">
            <div className="p-6">
              <h2 className="text-2xl font-semibold mb-4">Profile Info</h2>
              <p>Please fill baseline information about yourself</p>
            </div>
            <div className="border-b"></div>
            <form
              onSubmit={handleSubmit(togglePopup)}
              className="space-y-4 p-6"
            >
              <div className="font-bold text-custom-pink  text-xl">
                Personal Information
              </div>
              {/* Personal Information */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 border-b pb-4">
                <CommonTextField
                  name="firstName"
                  label="First Name"
                  register={register}
                  required
                  errors={errors}
                  placeholder="Enter First Name"
                  defaultValue={mentorProfile?.firstName}
                />
                <CommonTextField
                  name="lastName"
                  label="Last Name"
                  register={register}
                  required
                  errors={errors}
                  placeholder="Enter Last Name"
                  defaultValue={mentorProfile?.lastName}
                />
                <CommonDropdown
                  label="Gender"
                  name="gender"
                  required
                  register={register}
                  errors={errors}
                  defaultValue={mentorProfile?.gender}
                  value={watch("gender")}
                  options={[
                    { value: 0, label: "Male" },
                    { value: 1, label: "Female" },
                  ]}
                />
                <CommonDropdown
                  label="Country"
                  name="country"
                  required
                  register={register}
                  search={true}
                  errors={errors}
                  defaultValue={mentorProfile?.country}
                  value={watch("country")}
                  options={[
                    { value: "Afghanistan", label: "Afghanistan" },
                    { value: "Albania", label: "Albania" },
                    { value: "Algeria", label: "Algeria" },
                    { value: "Andorra", label: "Andorra" },
                    { value: "Angola", label: "Angola" },
                    {
                      value: "Antigua and Barbuda",
                      label: "Antigua and Barbuda",
                    },
                    { value: "Argentina", label: "Argentina" },
                    { value: "Armenia", label: "Armenia" },
                    { value: "Australia", label: "Australia" },
                    { value: "Austria", label: "Austria" },
                    { value: "Azerbaijan", label: "Azerbaijan" },
                    { value: "Bahamas", label: "Bahamas" },
                    { value: "Bahrain", label: "Bahrain" },
                    { value: "Bangladesh", label: "Bangladesh" },
                    { value: "Barbados", label: "Barbados" },
                    { value: "Belarus", label: "Belarus" },
                    { value: "Belgium", label: "Belgium" },
                    { value: "Belize", label: "Belize" },
                    { value: "Benin", label: "Benin" },
                    { value: "Bhutan", label: "Bhutan" },
                    { value: "Bolivia", label: "Bolivia" },
                    {
                      value: "Bosnia and Herzegovina",
                      label: "Bosnia and Herzegovina",
                    },
                    { value: "Botswana", label: "Botswana" },
                    { value: "Brazil", label: "Brazil" },
                    { value: "Brunei", label: "Brunei" },
                    { value: "Bulgaria", label: "Bulgaria" },
                    { value: "Burkina Faso", label: "Burkina Faso" },
                    { value: "Burundi", label: "Burundi" },
                    { value: "Cabo Verde", label: "Cabo Verde" },
                    { value: "Cambodia", label: "Cambodia" },
                    { value: "Cameroon", label: "Cameroon" },
                    { value: "Canada", label: "Canada" },
                    {
                      value: "Central African Republic",
                      label: "Central African Republic",
                    },
                    { value: "Chad", label: "Chad" },
                    { value: "Chile", label: "Chile" },
                    { value: "China", label: "China" },
                    { value: "Colombia", label: "Colombia" },
                    { value: "Comoros", label: "Comoros" },
                    {
                      value: "Congo (Congo-Brazzaville)",
                      label: "Congo (Congo-Brazzaville)",
                    },
                    { value: "Costa Rica", label: "Costa Rica" },
                    { value: "Croatia", label: "Croatia" },
                    { value: "Cuba", label: "Cuba" },
                    { value: "Cyprus", label: "Cyprus" },
                    { value: "Czechia", label: "Czechia" },
                    { value: "Denmark", label: "Denmark" },
                    { value: "Djibouti", label: "Djibouti" },
                    { value: "Dominica", label: "Dominica" },
                    {
                      value: "Dominican Republic",
                      label: "Dominican Republic",
                    },
                    { value: "Ecuador", label: "Ecuador" },
                    { value: "Egypt", label: "Egypt" },
                    { value: "El Salvador", label: "El Salvador" },
                    { value: "Equatorial Guinea", label: "Equatorial Guinea" },
                    { value: "Eritrea", label: "Eritrea" },
                    { value: "Estonia", label: "Estonia" },
                    { value: "Eswatini", label: "Eswatini" },
                    { value: "Ethiopia", label: "Ethiopia" },
                    { value: "Fiji", label: "Fiji" },
                    { value: "Finland", label: "Finland" },
                    { value: "France", label: "France" },
                    { value: "Gabon", label: "Gabon" },
                    { value: "Gambia", label: "Gambia" },
                    { value: "Georgia", label: "Georgia" },
                    { value: "Germany", label: "Germany" },
                    { value: "Ghana", label: "Ghana" },
                    { value: "Greece", label: "Greece" },
                    { value: "Grenada", label: "Grenada" },
                    { value: "Guatemala", label: "Guatemala" },
                    { value: "Guinea", label: "Guinea" },
                    { value: "Guyana", label: "Guyana" },
                    { value: "Haiti", label: "Haiti" },
                    { value: "Honduras", label: "Honduras" },
                    { value: "Hungary", label: "Hungary" },
                    { value: "Iceland", label: "Iceland" },
                    { value: "India", label: "India" },
                    { value: "Indonesia", label: "Indonesia" },
                    { value: "Iran", label: "Iran" },
                    { value: "Iraq", label: "Iraq" },
                    { value: "Ireland", label: "Ireland" },
                    { value: "Israel", label: "Israel" },
                    { value: "Italy", label: "Italy" },
                    { value: "Jamaica", label: "Jamaica" },
                    { value: "Japan", label: "Japan" },
                    { value: "Jordan", label: "Jordan" },
                    { value: "Kazakhstan", label: "Kazakhstan" },
                    { value: "Kenya", label: "Kenya" },
                    { value: "Kuwait", label: "Kuwait" },
                    { value: "Kyrgyzstan", label: "Kyrgyzstan" },
                    { value: "Laos", label: "Laos" },
                    { value: "Latvia", label: "Latvia" },
                    { value: "Lebanon", label: "Lebanon" },
                    { value: "Lesotho", label: "Lesotho" },
                    { value: "Liberia", label: "Liberia" },
                    { value: "Libya", label: "Libya" },
                    { value: "Liechtenstein", label: "Liechtenstein" },
                    { value: "Lithuania", label: "Lithuania" },
                    { value: "Luxembourg", label: "Luxembourg" },
                    { value: "Madagascar", label: "Madagascar" },
                    { value: "Malaysia", label: "Malaysia" },
                    { value: "Maldives", label: "Maldives" },
                    { value: "Mali", label: "Mali" },
                    { value: "Malta", label: "Malta" },
                    { value: "Mexico", label: "Mexico" },
                    { value: "Monaco", label: "Monaco" },
                    { value: "Mongolia", label: "Mongolia" },
                    { value: "Morocco", label: "Morocco" },
                    { value: "Mozambique", label: "Mozambique" },
                    { value: "Myanmar", label: "Myanmar" },
                    { value: "Namibia", label: "Namibia" },
                    { value: "Nepal", label: "Nepal" },
                    { value: "Netherlands", label: "Netherlands" },
                    { value: "New Zealand", label: "New Zealand" },
                    { value: "Nigeria", label: "Nigeria" },
                    { value: "Norway", label: "Norway" },
                    { value: "Pakistan", label: "Pakistan" },
                    { value: "Philippines", label: "Philippines" },
                    { value: "Poland", label: "Poland" },
                    { value: "Qatar", label: "Qatar" },
                    { value: "Russia", label: "Russia" },
                    { value: "Saudi Arabia", label: "Saudi Arabia" },
                    { value: "South Africa", label: "South Africa" },
                    { value: "United Kingdom", label: "United Kingdom" },
                    { value: "United States", label: "United States" },
                  ]}
                />

                <CommonTextField
                  name="state"
                  label="State / Province"
                  register={register}
                  required
                  errors={errors}
                  placeholder="State / Province"
                  defaultValue={mentorProfile?.state}
                />
                <CommonTextField
                  name="city"
                  label="City"
                  register={register}
                  required
                  errors={errors}
                  placeholder="City"
                  defaultValue={mentorProfile?.city}
                />
                <CommonDropdown
                  label="Age Group"
                  name="ageGroup"
                  register={register}
                  required
                  errors={errors}
                  defaultValue={mentorProfile?.ageGroup}
                  value={watch("ageGroup")}
                  options={ageGroup}
                />
                <CommonDropdown
                  label="Race"
                  name="race"
                  register={register}
                  required
                  errors={errors}
                  defaultValue={mentorProfile?.race}
                  value={watch("race")}
                  options={race}
                />
                <CommonTextField
                  label="Email"
                  name="email"
                  register={register}
                  required
                  errors={errors}
                  placeholder="Email"
                  defaultValue={mentorProfile?.email}
                  readOnly
                />
                <FlexibleTextarea
                  name="bio"
                  placeholder="Bio"
                  label="About Me"
                  required={true}
                  outerClassName="w-full col-span-1 md:col-span-2"
                  errors={errors}
                  register={register}
                  defaultValue={mentorProfile?.bio} 
                />
              </div>

              <div className="font-bold text-xl text-custom-pink ">
                Educational & Professional Background
              </div>
              {/* Educational & Professional Background */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 border-b pb-4">
                <CommonDropdown
                  label="Highest Education level"
                  name="education"
                  required
                  register={register}
                  errors={errors}
                  defaultValue={mentorProfile?.higherEducationLevel}
                  value={watch("education")}
                  options={education}
                />
                <CommonDropdown
                  label="Employment Status"
                  name="employmentStatus"
                  required
                  register={register}
                  errors={errors}
                  defaultValue={mentorProfile?.employmentStatus}
                  value={watch("employmentStatus")}
                  options={status}
                />
                <CommonDropdown
                  label="Professional Experience"
                  name="professionalExperience"
                  required
                  register={register}
                  errors={errors}
                  defaultValue={mentorProfile?.professionalExperience}
                  value={watch("professionalExperience")}
                  options={experience}
                />
                <CommonDropdown
                  label="Years of Work Experience"
                  name="yearsOfExperience"
                  required
                  register={register}
                  errors={errors}
                  placeholder="Years of Work Experience"
                  defaultValue={mentorProfile?.yearOfExperience}
                  value={watch("yearsOfExperience")}
                  options={workYears}
                />

                <CommonDropdown
                  label="Current Job / Experience"
                  name="jobTitle"
                  required
                  register={register}
                  errors={errors}
                  defaultValue={mentorProfile?.currentJobOccupation}
                  value={watch("jobTitle")}
                  options={options}
                  search={true}
                />

                {isLoadingIndustries ? (
                  <div className="space-y-2">
                    <label className="font-bold text-base text-gray-700">Industry *</label>
                    <div className="flex items-center justify-center py-3 px-4 border border-gray-300 rounded-lg bg-gray-50">
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-purple-600 mr-2"></div>
                      <span className="text-gray-600 text-sm">Loading industry options...</span>
                    </div>
                  </div>
                ) : (
                  <CommonDropdown
                    label="Industry"
                    name="industry"
                    required
                    register={register}
                    errors={errors}
                    defaultValue={mentorProfile?.industry}
                    value={watch("industry")}
                    options={industryData}
                    search={true}
                  />
                )}

                <FlexibleTextarea
                  name={"mentorExperiance"}
                  placeholder="Write a brief about your professional experience"
                  label={"Professional Experience"}
                  required={true}
                  outerClassName="w-full col-span-2"
                  errors={errors} // ✅ Fix: Ensure this is passed
                  register={register}
                  defaultValue={mentorProfile?.mentorExperiance}
                />
                <FlexibleTextarea
                  name={"mentorReason"}
                  placeholder="Why do you want to be a mentor?"
                  label={"Why Do You Want To Be a Mentor"}
                  required={true}
                  outerClassName="w-full col-span-2"
                  errors={errors} // ✅ Fix: Ensure this is passed
                  register={register}
                  defaultValue={mentorProfile?.whyDoYouWantToBeMentor}
                />
              </div>

              <div className="text-custom-pink  font-bold text-xl">
                Mentoring Experiences
              </div>
              {/* Mentoring Experience */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <CommonDropdown
                  label="Any Formal Mentoring or Coaching Experience"
                  name="mentoringExperience"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile?.formalMentoringOrCoachingExperience
                  }
                  value={watch("mentoringExperience")}
                  options={selectYesNO}
                />
                <CommonDropdown
                  label="Years of Mentoring Experience"
                  name="yearsOfMentoring"
                  required
                  register={register}
                  errors={errors}
                  defaultValue={`${mentorProfile?.yearsOfMentoring}`}
                  value={watch("yearsOfMentoring")}
                  options={workYears}
                />
              </div>

              <div className="text-custom-pink  font-bold text-xl border-t pt-4">
                Mentoring Focus Areas
              </div>

              {/* Skills */}
              <div className="grid grid-cols-2 gap-4">
                <MultiSelectDropDown
                  label="General Career Mentoring/Coaching"
                  name="general"
                  search={true}
                  defaultValue={mentorProfile?.general}
                  register={register}
                  errors={errors}
                  options={[
                    {
                      value: "career",
                      label: "Career Advancement/Transition",
                    },
                    { value: "employment", label: "Employment/Job Search" },
                    { value: "resume", label: "Resume Optimization" },
                    {
                      value: "linkdin",
                      label: "LinkedIn Profile Optimization",
                    },
                  ]}
                  value={watch("general") || []}
                  onChange={(selectedValues) => {
                    setValue("general", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
              </div>
              <div className="font-bold text-blue-700  text-xl pt-4">
                AI Skills
              </div>
              <div className="grid grid-cols-2 gap-4">
                <MultiSelectDropDown
                  label="Foundational AI Literacy (For Everyone)"
                  name="AILiteracySkills"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile ? mentorProfile.AILiteracySkills : ""
                  }
                  options={AILiteracySkills}
                  value={watch("AILiteracySkills") || []}
                  onChange={(selectedValues) => {
                    setValue("AILiteracySkills", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
                <MultiSelectDropDown
                  label="Applied AI Skills (For Business & Industry Roles)"
                  name="appliedAISkills"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile ? mentorProfile.appliedAISkills : ""
                  }
                  options={appliedAISkills}
                  value={watch("appliedAISkills") || []}
                  onChange={(selectedValues) => {
                    setValue("appliedAISkills", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
                <MultiSelectDropDown
                  label="AI Ethics & Responsible AI"
                  name="ethicsResponsibleAI"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile ? mentorProfile.ethicsResponsibleAI : ""
                  }
                  options={ResponsibleAI}
                  value={watch("ethicsResponsibleAI") || []}
                  onChange={(selectedValues) => {
                    setValue("ethicsResponsibleAI", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />

                <MultiSelectDropDown
                  label="Soft Skills for the AI Era"
                  name="softAISkills"
                  register={register}
                  errors={errors}
                  defaultValue={mentorProfile ? mentorProfile.softAISkills : ""}
                  options={softAISkills}
                  value={watch("softAISkills") || []}
                  onChange={(selectedValues) => {
                    setValue("softAISkills", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
                <MultiSelectDropDown
                  label="Strategic AI Skills"
                  name="strategicAISkills"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile ? mentorProfile.strategicAISkills : ""
                  }
                  options={strategicAISkills}
                  value={watch("strategicAISkills") || []}
                  onChange={(selectedValues) => {
                    setValue("strategicAISkills", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
                <MultiSelectDropDown
                  label="Technical AI Skills for Practioners and Developers"
                  name="technicalAISkills"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile ? mentorProfile.emergingAISkills : ""
                  }
                  options={technicalAISkills}
                  value={watch("technicalAISkills") || []}
                  onChange={(selectedValues) => {
                    setValue("technicalAISkills", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
              </div>
              <div className="font-bold text-xl pt-4 text-blue-700">
                AI Careers
              </div>
              <div className="grid grid-cols-2 gap-4">
                <MultiSelectDropDown
                  label="Technical & Development Roles"
                  name="TechnicalDevelopmentRoles"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile ? mentorProfile.TechnicalDevelopmentRoles : ""
                  }
                  options={TechnicalDevelopmentRoles}
                  value={watch("TechnicalDevelopmentRoles") || []}
                  onChange={(selectedValues) => {
                    setValue("TechnicalDevelopmentRoles", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
                <MultiSelectDropDown
                  label="Infrastructure & MLOps Roles"
                  name="InfrastureRoles"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile ? mentorProfile.InfrastureRoles : ""
                  }
                  options={InfrastructureMLOpsRoles}
                  value={watch("InfrastureRoles") || []}
                  onChange={(selectedValues) => {
                    setValue("InfrastureRoles", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
                <MultiSelectDropDown
                  label="Ethics, Safety & Governance Roles"
                  name="ethicsRoles"
                  register={register}
                  errors={errors}
                  defaultValue={mentorProfile ? mentorProfile.ethicsRoles : ""}
                  options={EthicsSafetyGovernanceRoles}
                  value={watch("ethicsRoles") || []}
                  onChange={(selectedValues) => {
                    setValue("ethicsRoles", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />

                <MultiSelectDropDown
                  label="Business, Strategy & Design Roles"
                  name="buisnessRole"
                  register={register}
                  errors={errors}
                  defaultValue={mentorProfile ? mentorProfile.buisnessRole : ""}
                  options={BusinessStrategyDesignRoles}
                  value={watch("buisnessRole") || []}
                  onChange={(selectedValues) => {
                    setValue("buisnessRole", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
                <MultiSelectDropDown
                  label="Creative & Interdisciplinary Roles"
                  name="CreativeRole"
                  register={register}
                  errors={errors}
                  defaultValue={mentorProfile ? mentorProfile.CreativeRole : ""}
                  options={CreativeInterdisciplinaryRoles}
                  value={watch("CreativeRole") || []}
                  onChange={(selectedValues) => {
                    setValue("CreativeRole", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
                <MultiSelectDropDown
                  label="Compliance"
                  name="Compliance"
                  register={register}
                  errors={errors}
                  defaultValue={mentorProfile ? mentorProfile.Compliance : ""}
                  options={Compliance}
                  value={watch("Compliance") || []}
                  onChange={(selectedValues) => {
                    setValue("Compliance", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
                <MultiSelectDropDown
                  label="Emerging AI"
                  name="EmergingAI"
                  register={register}
                  errors={errors}
                  defaultValue={mentorProfile ? mentorProfile.EmergingAI : ""}
                  options={EmergingAI}
                  value={watch("EmergingAI") || []}
                  onChange={(selectedValues) => {
                    setValue("EmergingAI", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
              </div>
              <div className="font-bold text-xl pt-4 text-blue-700">
                AI Tools
              </div>
              <div className="grid grid-cols-2 gap-4">
                <MultiSelectDropDown
                  label="Machine Learning & Deep Learning Platforms"
                  name="MachineLearningDeepLearningPlatforms"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile
                      ? mentorProfile.MachineLearningDeepLearningPlatforms
                      : ""
                  }
                  options={MachineLearningDeepLearningPlatforms}
                  value={watch("MachineLearningDeepLearningPlatforms") || []}
                  onChange={(selectedValues) => {
                    setValue(
                      "MachineLearningDeepLearningPlatforms",
                      selectedValues,
                      {
                        shouldValidate: true,
                      }
                    );
                  }}
                />
                <MultiSelectDropDown
                  label="AutoML & No-Code/Low-Code AI Platforms"
                  name="AutoMLNoCodeLowCodeAIPlatforms"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile
                      ? mentorProfile.AutoMLNoCodeLowCodeAIPlatforms
                      : ""
                  }
                  options={AutoMLNoCodeLowCodeAIPlatforms}
                  value={watch("AutoMLNoCodeLowCodeAIPlatforms") || []}
                  onChange={(selectedValues) => {
                    setValue("AutoMLNoCodeLowCodeAIPlatforms", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
                <MultiSelectDropDown
                  label="Natural Language Processing (NLP) Tools"
                  name="NaturalLanguageProcessingTools"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile
                      ? mentorProfile.NaturalLanguageProcessingTools
                      : ""
                  }
                  options={NaturalLanguageProcessingTools}
                  value={watch("NaturalLanguageProcessingTools") || []}
                  onChange={(selectedValues) => {
                    setValue("NaturalLanguageProcessingTools", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />

                <MultiSelectDropDown
                  label="Computer Vision Tools"
                  name="ComputerVisionTools"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile ? mentorProfile.ComputerVisionTools : ""
                  }
                  options={ComputerVisionTools}
                  value={watch("ComputerVisionTools") || []}
                  onChange={(selectedValues) => {
                    setValue("ComputerVisionTools", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
                <MultiSelectDropDown
                  label="Generative AI Tools"
                  name="GenerativeAITools"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile ? mentorProfile.GenerativeAITools : ""
                  }
                  options={GenerativeAITools}
                  value={watch("GenerativeAITools") || []}
                  onChange={(selectedValues) => {
                    setValue("GenerativeAITools", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
                <MultiSelectDropDown
                  label="MLOps & Deployment Tools"
                  name="MLOpsDeploymentTools"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile ? mentorProfile.MLOpsDeploymentTools : ""
                  }
                  options={MLOpsDeploymentTools}
                  value={watch("MLOpsDeploymentTools") || []}
                  onChange={(selectedValues) => {
                    setValue("MLOpsDeploymentTools", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
                <MultiSelectDropDown
                  label="Data Science & Visualization Tools"
                  name="DataScienceVisualizationTools"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile
                      ? mentorProfile.DataScienceVisualizationTools
                      : ""
                  }
                  options={DataScienceVisualizationTools}
                  value={watch("DataScienceVisualizationTools") || []}
                  onChange={(selectedValues) => {
                    setValue("DataScienceVisualizationTools", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
              </div>

              <div className="font-bold text-xl pt-4 text-blue-700">
                Soft Skills
              </div>
              <div className="grid grid-cols-2 gap-4">
                <MultiSelectDropDown
                  label="Communication Skills"
                  name="CommunicationSkills"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile ? mentorProfile.CommunicationSkills : ""
                  }
                  options={CommunicationSkills}
                  value={watch("CommunicationSkills") || []}
                  onChange={(selectedValues) => {
                    setValue("CommunicationSkills", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
                <MultiSelectDropDown
                  label="Interpersonal & Teamwork Skills"
                  name="InterpersonalTeamworkSkills"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile
                      ? mentorProfile.InterpersonalTeamworkSkills
                      : ""
                  }
                  options={InterpersonalTeamworkSkills}
                  value={watch("InterpersonalTeamworkSkills") || []}
                  onChange={(selectedValues) => {
                    setValue("InterpersonalTeamworkSkills", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
                <MultiSelectDropDown
                  label="Critical Thinking & Problem Solving"
                  name="CriticalThinkingProblemSolving"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile
                      ? mentorProfile.CriticalThinkingProblemSolving
                      : ""
                  }
                  options={CriticalThinkingProblemSolving}
                  value={watch("CriticalThinkingProblemSolving") || []}
                  onChange={(selectedValues) => {
                    setValue("CriticalThinkingProblemSolving", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />

                <MultiSelectDropDown
                  label="Self-Management Skills"
                  name="SelfManagementSkills"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile ? mentorProfile.SelfManagementSkills : ""
                  }
                  options={SelfManagementSkills}
                  value={watch("SelfManagementSkills") || []}
                  onChange={(selectedValues) => {
                    setValue("SelfManagementSkills", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
                <MultiSelectDropDown
                  label="Leadership & Influence"
                  name="LeadershipInfluence"
                  register={register}
                  errors={errors}
                  defaultValue={
                    mentorProfile ? mentorProfile.LeadershipInfluence : ""
                  }
                  options={LeadershipInfluence}
                  value={watch("LeadershipInfluence") || []}
                  onChange={(selectedValues) => {
                    setValue("LeadershipInfluence", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <MultiSelectDropDown
                  label="AI Application / Transformation by Industry"
                  name="ai_application"
                  register={register}
                  errors={errors}
                  options={industries}
                  value={watch("ai_application") || []}
                  onChange={(selectedValues) => {
                    setValue("ai_application", selectedValues, {
                      shouldValidate: true,
                    });
                  }}
                />

                <CommonDropdown
                  label="Technology"
                  name="technology"
                  register={register}
                  errors={errors}
                  defaultValue={mentorProfile?.technology}
                  value={watch("technology")}
                  options={technologies}
                />
              </div>
              <div className="font-bold text-xl text-blue-700 border-t pt-4">
                Other Services
              </div>

              {/* Skills */}
              <div className="grid grid-cols-2 gap-4">
                <CommonDropdown
                  label="Open To Volunteer Mentoring Session"
                  name="openToVolunteer"
                  register={register}
                  errors={errors}
                  defaultValue={mentorProfile?.openToVolunteer}
                  value={watch("openToVolunteer")}
                  options={selectYesNO}
                />
                {openToVolunteer === "yes" && (
                  <>
                    <CommonDropdown
                      label="Maximun number of volunteer sessions per year"
                      name="maximumNumbers"
                      register={register}
                      errors={errors}
                      defaultValue={mentorProfile?.maximumNumbers}
                      value={watch("maximumNumbers")}
                      options={[
                        { label: "1", value: "1" },
                        { label: "2", value: "2" },
                        { label: "3", value: "3" },
                        { label: "4", value: "4" },
                        { label: "5", value: "5" },
                        { label: "6", value: "6" },
                        { label: "7", value: "7" },
                        { label: "8", value: "8" },
                        { label: "9", value: "9" },
                        { label: "10", value: "10" },
                      ]}
                    />
                    <CommonDropdown
                      label="Volunteer Mins/ Sessions"
                      name="volunteerMins"
                      register={register}
                      errors={errors}
                      defaultValue={mentorProfile?.volunteerMins}
                      value={watch("volunteerMins")}
                      options={[
                        { label: "60 Min", value: "30" },
                        { label: "45 Min", value: "45" },
                        { label: "30 Min", value: "60" },
                      ]}
                    />
                  </>
                )}
                <CommonDropdown
                  label="Open To Group Mentoring  Session"
                  name="openToGroup"
                  register={register}
                  errors={errors}
                  defaultValue={mentorProfile?.openToGroup}
                  value={watch("openToGroup")}
                  options={selectYesNO}
                />
                {openToGroup === "yes" && (
                  <>
                    <CommonTextField
                      label={"Price per mentee for a group of 8 mentees"}
                      register={register}
                      errors={errors}
                      name={"pricePerMentee"}
                      defaultValue={mentorProfile?.pricePerMentee}
                      setValue={setValue}
                    />
                    <CommonTextField
                      label={"Mins / Session"}
                      register={register}
                      errors={errors}
                      name={"minSession"}
                      defaultValue={mentorProfile?.minSession}
                      setValue={setValue}
                    />
                  </>
                )}
                <CommonDropdown
                  label="Open to Facilitating Webinars / Masterclasses / Workshops / Online Courses"
                  name="openToFacilitating"
                  register={register}
                  errors={errors}
                  defaultValue={mentorProfile?.openToFacilitating}
                  value={watch("openToFacilitating")}
                  options={selectYesNO}
                />
                <CommonDropdown
                  label="Open to Consutling with Buisnesses about AI Transfromation or Services"
                  name="openToConsulting"
                  register={register}
                  errors={errors}
                  defaultValue={mentorProfile?.openToConsulting}
                  value={watch("openToConsulting")}
                  options={selectYesNO}
                />
              </div>

              <div className="font-bold text-custom-pink text-xl border-t pt-4">
                Certification Upload{" "}
                <span className="font-normal text-sm text-gray-400">
                  {" "}
                  (optional)
                </span>
              </div>
              <CertificationUpload
                register={register}
                handleSubmit={onSubmit}
                errors={errors}
                setValue={setValue}
              />

              {/* Social Media Links */}
              <div className="font-bold text-custom-pink text-xl border-t pt-4">
                Social Media Links
              </div>
              <div className="flex justify-between flex-wrap">
                <TextInputIcon
                  type="url"
                  name="linkedIn"
                  label="LinkedIn URL"
                  register={register}
                  required
                  errors={errors}
                  defaultValue={mentorProfile?.linkedIn}
                  placeholder="LinkedIn URL"
                  icon={<FaLinkedin className="text-[#0270AD] text-2xl " />}
                  iconPosition="left"
                />
                <TextInputIcon
                  type="url"
                  name="twitter"
                  label="Twitter URL (optional)"
                  register={register}
                  errors={errors}
                  placeholder="Twitter URL"
                  icon={
                    <BsTwitterX className="text-white p-1 text-2xl bg-black " />
                  }
                  iconPosition="left"
                />

                <TextInputIcon
                  type="url"
                  name="personalWebsite"
                  label="Personal Website (optional)"
                  register={register}
                  errors={errors}
                  placeholder="Personal Website"
                  icon={<Earth className="w-5" />}
                  iconPosition="left"
                />
              </div>

              <div className="font-bold text-custom-pink text-xl border-t pt-4">
                Documents Uploads
              </div>

              <div className="w-full flex flex-col md:flex-row gap-4">
                {/* File Uploads */}
                <FileUploader
                  name="photo"
                  label="Upload photo"
                  register={register}
                  required
                  errors={errors}
                  placeholder="Your Photo"
                  defaultValue={mentorProfile?.profileImage}
                  accept="image/*"
                  onFileSelect={(file) => {
                    setValue("photo", file);
                  }}
                />
                <FileUploader
                  name="cv"
                  label="CV"
                  register={register}
                  required
                  errors={errors}
                  placeholder="Your CV"
                  defaultValue={mentorProfile?.cv}
                  accept=".pdf,.doc,.docx"
                  onFileSelect={(file) => {
                    setValue("cv", file);
                  }}
                />
              </div>

              {/* Submit */}
              <div className="flex flex-col gap-2 sm:flex-row sm:justify-end sm:items-center lg:gap-4 mt-6">
                <CustomButton
                  type="submit"
                  label={
                    loading
                      ? id
                        ? "Updating"
                        : "Saving..."
                      : id
                      ? "Update"
                      : "Submit"
                  }
                  buttonClass="bg-custom-gradient px-[20px] py-[9px] rounded-lg w-full sm:w-[138px]"
                  disabled={loading}
                />
              </div>
            </form>
          </div>
          {showPopup && (
            <div className="fixed inset-0 z-[1400] flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white rounded-lg shadow-lg max-w-3xl w-full max-h-[80vh] overflow-y-auto p-6 relative">
                <h3 className="text-xl font-bold mb-4">
                  Mentoring Agreement Contract
                </h3>
                <div>
                  <p class="mb-6">
                    This Mentoring Agreement (“Agreement”) is made and entered
                    into on the
                    <span class="font-bold">{` ${formattedDate} `}</span>
                    (“Effective Date”), by and between:
                  </p>

                  <ol class="list-decimal pl-6 mb-6 space-y-2">
                    <li>
                      <span className="font-bold">Ontrack Careers</span>,
                      hereinafter referred to as{" "}
                      <span className="font-bold">“Ontrack Careers”</span> or
                      the
                      <span className="font-bold">“Organization”</span>,
                    </li>
                    <li>
                      <span className="font-bold">
                        {mentorProfile.firstName} {mentorProfile.lastName}
                      </span>
                      , an individual residing at {mentorProfile.city},{" "}
                      {mentorProfile?.state || ""}, {mentorProfile.country},
                      hereinafter referred to as the{" "}
                      <span className="font-bold">“Mentor.”</span>
                    </li>
                  </ol>

                  <p class="mb-6">
                    Collectively, Ontrack Careers and the Mentor may be referred
                    to as the <span className="font-bold">“Parties,” </span>and
                    individually as a{" "}
                    <span className="font-bold">“Party.”</span>
                  </p>

                  <div className="space-y-8">
                    {/* Section 1 */}
                    <div>
                      <h2 className="text-xl font-bold text-gray-700 mb-2">
                        1. Purpose of the Agreement
                      </h2>
                      <p className="text-gray-700 mb-2">
                        1.1 The purpose of this Agreement is to outline the
                        relationship and responsibilities between Ontrack
                        Careers and the Mentor, who will provide mentoring
                        services (the "Services") to mentees enrolled or engaged
                        with Ontrack Careers' programs.
                      </p>
                      <p className="text-gray-700">
                        1.2 This Agreement sets forth the terms and conditions
                        under which the Mentor will provide professional
                        guidance, support, and advice to individuals ("Mentees")
                        within the framework established by Ontrack Careers.
                      </p>
                    </div>

                    {/* Section 2 */}
                    <div>
                      <h2 className="text-xl font-bold text-gray-700 mb-2">
                        2. Mentor's Roles & Responsibilities
                      </h2>
                      <p className="text-gray-700 mb-2">
                        2.1 Mentoring Services: The Mentor agrees to provide
                        mentoring services to Mentees, including but not limited
                        to:
                      </p>
                      <ul className="list-disc pl-8 mb-2 space-y-1">
                        <li>One-on-one or group coaching sessions.</li>
                        <li>
                          Guidance on professional development, career planning,
                          and skill enhancement.
                        </li>
                        <li>
                          Feedback on personal or professional challenges faced
                          by Mentees.
                        </li>
                      </ul>
                      <p className="text-gray-700 mb-2">
                        2.2 Booked Session Commitment: The Mentor agrees to
                        commit to meet with the mentee at the agreed booked time
                        by the mentee.
                      </p>
                      <p className="text-gray-700 mb-2">
                        2.3 Code of Conduct: The Mentor agrees to adhere to the
                        highest ethical, moral, and professional standards,
                        including:
                      </p>
                      <ul className="list-disc pl-8 mb-2 space-y-1">
                        <li>
                          Respecting cultural diversity and individual
                          differences.
                        </li>
                        <li>Avoiding conflicts of interest.</li>
                        <li>Providing honest and constructive feedback.</li>
                      </ul>
                      <p className="text-gray-700">
                        2.4 Compliance: The Mentor agrees to comply with any
                        applicable laws, regulations, and Ontrack Careers'
                        policies while performing the Services.
                      </p>
                    </div>

                    {/* Section 3 */}
                    <div>
                      <h2 className="text-xl font-bold text-gray-700 mb-2">
                        3. Ontrack Careers' Roles & Responsibilities
                      </h2>
                      <p className="text-gray-700 mb-2">
                        3.1 Program Coordination: Ontrack Careers agrees to
                        provide the Mentor with reasonable support, resources,
                        and coordination necessary for successful mentoring
                        engagements, such as:
                      </p>
                      <ul className="list-disc pl-8 mb-2 space-y-1">
                        <li>Matching the Mentor with appropriate Mentees.</li>
                        <li>
                          Providing relevant background information about the
                          Mentees (with consent).
                        </li>
                        <li>
                          Scheduling guidelines, tools, or platforms for
                          sessions.
                        </li>
                      </ul>
                      <p className="text-gray-700 mb-2">
                        3.2 Mentor Support: Ontrack Careers will offer ongoing
                        assistance and clarity regarding program objectives,
                        processes, and documentation.
                      </p>
                      <p className="text-gray-700 mb-2">
                        3.3 Compensation (if applicable): Where compensation is
                        agreed upon, Ontrack Careers will pay the Mentor at a
                        rate the agreed rate as otherwise agreed in writing.
                      </p>
                      <p className="text-gray-700">
                        3.4 Feedback & Evaluation: Ontrack Careers may provide
                        feedback to the Mentor regarding the mentoring sessions
                        and outcomes to ensure continuous improvement of the
                        program.
                      </p>
                    </div>

                    {/* Section 4 */}
                    <div>
                      <h2 className="text-xl font-bold text-gray-700 mb-2">
                        4. Confidentiality
                      </h2>
                      <p className="text-gray-700 mb-2">
                        4.1 Confidential Information: Both Parties acknowledge
                        that during the course of providing mentoring services,
                        the Mentor may have access to confidential or
                        proprietary information of Ontrack Careers and/or
                        Mentees, including but not limited to personal
                        information, trade secrets, intellectual property,
                        business strategies, and other sensitive data
                        (collectively, "Confidential Information").
                      </p>
                      <p className="text-gray-700 mb-2">
                        4.2 Obligations: The Mentor agrees:
                      </p>
                      <ul className="list-disc pl-8 mb-2 space-y-1">
                        <li>
                          To maintain all Confidential Information in strict
                          confidence.
                        </li>
                        <li>
                          Not to disclose any Confidential Information to any
                          third party without the prior written consent of
                          Ontrack Careers.
                        </li>
                        <li>
                          To use Confidential Information solely for the purpose
                          of fulfilling obligations under this Agreement.
                        </li>
                      </ul>
                      <p className="text-gray-700">
                        4.3 Exclusions: Confidential Information does not
                        include information that:
                      </p>
                      <ul className="list-disc pl-8 mt-1 space-y-1">
                        <li>
                          Is or becomes publicly available without breach of
                          this Agreement.
                        </li>
                        <li>
                          Is lawfully obtained from a third party without
                          restriction.
                        </li>
                        <li>
                          Is already known by the Mentor prior to receipt from
                          Ontrack Careers.
                        </li>
                        <li>
                          Is required to be disclosed by law or valid court
                          order.
                        </li>
                      </ul>
                    </div>

                    {/* Section 5 */}
                    <div>
                      <h2 className="text-xl font-bold text-gray-700 mb-2">
                        5. Intellectual Property
                      </h2>
                      <p className="text-gray-700 mb-2">
                        5.1 Ownership: All intellectual property, including but
                        not limited to logos, materials, content, and platforms
                        provided by Ontrack Careers, remains the exclusive
                        property of Ontrack Careers. The Mentor may not
                        reproduce, distribute, or modify such materials without
                        written consent.
                      </p>
                      <p className="text-gray-700">
                        5.2 Mentor Materials: Any materials created
                        independently by the Mentor and used in the Services
                        remain the property of the Mentor unless otherwise
                        agreed. However, the Mentor grants Ontrack Careers a
                        non-exclusive, royalty-free license to use such
                        materials during the term of this Agreement to
                        facilitate the mentoring program.
                      </p>
                    </div>

                    {/* Section 6 */}
                    <div>
                      <h2 className="text-xl font-bold text-gray-700 mb-2">
                        6. Term & Termination
                      </h2>
                      <p className="text-gray-700 mb-2">
                        6.1 Term: This Agreement is effective as of the
                        Effective Date and shall continue for a period of
                        [specify duration, e.g., 6 months, 1 year], unless
                        sooner terminated as provided herein.
                      </p>
                      <p className="text-gray-700 mb-2">
                        6.2 Termination for Convenience: Either Party may
                        terminate this Agreement for any reason upon [30 days']
                        written notice to the other Party.
                      </p>
                      <p className="text-gray-700 mb-2">
                        6.3 Termination for Cause: Either Party may terminate
                        this Agreement immediately if the other Party:
                      </p>
                      <ul className="list-disc pl-8 mb-2 space-y-1">
                        <li>
                          Materially breaches any obligation under this
                          Agreement and fails to cure such breach within [15
                          days] of written notice.
                        </li>
                        <li>
                          Engages in conduct that is fraudulent, unethical, or
                          otherwise damaging to the reputation of the other
                          Party or its stakeholders.
                        </li>
                      </ul>
                      <p className="text-gray-700">
                        6.4 Effects of Termination:
                      </p>
                      <ul className="list-disc pl-8 mt-1 space-y-1">
                        <li>
                          The Mentor shall cease all mentoring activities upon
                          the effective date of termination.
                        </li>
                        <li>
                          Any outstanding compensation or reimbursements owed to
                          the Mentor shall become due and payable.
                        </li>
                        <li>
                          The Mentor shall return or destroy all Confidential
                          Information at the request of Ontrack Careers, subject
                          to any legal obligations regarding retention.
                        </li>
                      </ul>
                    </div>

                    {/* Section 7 */}
                    <div>
                      <h2 className="text-xl font-bold text-gray-700 mb-2">
                        7. Indemnification & Liability
                      </h2>
                      <p className="text-gray-700 mb-2">
                        7.1 Mentor Indemnification: The Mentor agrees to
                        indemnify, defend, and hold harmless Ontrack Careers
                        from and against any and all claims, liabilities,
                        damages, and expenses (including reasonable attorneys'
                        fees) arising from or relating to the Mentor's
                        negligence, willful misconduct, or breach of this
                        Agreement.
                      </p>
                      <p className="text-gray-700">
                        7.2 Ontrack Careers' Limitation of Liability: Ontrack
                        Careers shall not be liable to the Mentor for any
                        indirect, incidental, special, or consequential damages
                        arising out of or related to this Agreement. In no event
                        shall Ontrack Careers' aggregate liability exceed the
                        total compensation paid to the Mentor under this
                        Agreement in the six (6) months preceding the event
                        giving rise to the claim.
                      </p>
                    </div>

                    {/* Section 8 */}
                    <div>
                      <h2 className="text-xl font-bold text-gray-700 mb-2">
                        8. Independent Contractor Relationship
                      </h2>
                      <p className="text-gray-700 mb-2">
                        8.1 Status: The Mentor is an independent contractor and
                        is not an employee, agent, partner, or joint venture of
                        Ontrack Careers. Nothing in this Agreement shall be
                        construed to create an employer-employee relationship or
                        any partnership or agency relationship.
                      </p>
                      <p className="text-gray-700">
                        8.2 Taxes & Benefits: The Mentor is solely responsible
                        for the payment of all taxes, withholdings, and other
                        statutory obligations arising out of the compensation
                        received under this Agreement. The Mentor is not
                        entitled to receive any employee benefits from Ontrack
                        Careers.
                      </p>
                    </div>

                    {/* Section 9 */}
                    <div>
                      <h2 className="text-xl font-bold text-gray-700 mb-2">
                        9. Non-Exclusivity
                      </h2>
                      <p className="text-gray-700">
                        The Mentor is free to provide similar services to other
                        organizations or individuals, provided that such
                        activities do not interfere with the Mentor's
                        obligations under this Agreement, and do not violate any
                        of the confidentiality provisions or conflict of
                        interest rules set forth herein.
                      </p>
                    </div>

                    {/* Section 10 */}
                    <div>
                      <h2 className="text-xl font-bold text-gray-700 mb-2">
                        10. Dispute Resolution
                      </h2>
                      <p className="text-gray-700 mb-2">
                        10.1 Good Faith Negotiations: In the event of a dispute,
                        controversy, or claim arising out of or relating to this
                        Agreement, the Parties agree to attempt to resolve the
                        matter through good-faith discussions.
                      </p>
                      <p className="text-gray-700 mb-2">
                        10.2 Governing Law: This Agreement shall be governed by
                        and construed in accordance with the laws of [the
                        jurisdiction of Ontrack Careers], without regard to its
                        conflict of law provisions.
                      </p>
                      <p className="text-gray-700">
                        10.3 Venue: Any dispute arising out of or related to
                        this Agreement that cannot be resolved amicably shall be
                        settled in the courts located in [specify jurisdiction].
                      </p>
                    </div>

                    {/* Section 11 */}
                    <div>
                      <h2 className="text-xl font-bold text-gray-700 mb-2">
                        11. General Provisions
                      </h2>
                      <p className="text-gray-700 mb-2">
                        11.1 Entire Agreement: This Agreement constitutes the
                        entire agreement between the Parties regarding the
                        subject matter herein and supersedes all prior
                        agreements, understandings, or representations.
                      </p>
                      <p className="text-gray-700 mb-2">
                        11.2 Amendments: This Agreement may be amended or
                        modified only by a written document signed by both
                        Parties.
                      </p>
                      <p className="text-gray-700 mb-2">
                        11.3 Severability: If any provision of this Agreement is
                        found to be invalid or unenforceable, the remaining
                        provisions shall remain in full force and effect.
                      </p>
                      <p className="text-gray-700 mb-2">
                        11.4 Waiver: The failure of either Party to enforce any
                        provision of this Agreement shall not be construed as a
                        waiver of that provision or any other provision.
                      </p>
                      <p className="text-gray-700">
                        11.5 Notices: Any notice required or permitted under
                        this Agreement shall be deemed to have been given if in
                        writing and delivered personally or mailed via certified
                        or registered mail to the respective addresses of the
                        Parties as stated at the beginning of this Agreement (or
                        to such other address a Party may designate in writing).
                      </p>
                    </div>
                  </div>

                  <section class="mt-10">
                    <h2 class="text-xl font-semibold mb-4">12. Signatures</h2>
                    <p class="mb-6">
                      IN WITNESS WHEREOF, the Parties have executed this
                      Mentoring Agreement as of the Effective Date stated above.
                    </p>

                    <div class="grid md:grid-cols-2 gap-10">
                      <div>
                        <p class="font-bold">Ontrack Careers</p>
                        <div class="mt-4 space-y-4">
                          <p>By: On Track Careers</p>
                          <p>Name: On Track Careers</p>
                          <p>Date: {formattedDate}</p>{" "}
                        </div>
                      </div>
                      <div>
                        <p class="font-bold">Mentor</p>
                        <div class="mt-4 space-y-4">
                          <p>
                            By: {mentorProfile.firstName}{" "}
                            {mentorProfile.lastName}
                          </p>
                          <p>
                            Name: {mentorProfile.firstName}{" "}
                            {mentorProfile.lastName}
                          </p>
                          <p>Date: {formattedDate}</p>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
                <div className="flex items-center mb-4 mt-5">
                  <input
                    id="termsCheckbox"
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => setIsChecked(e.target.checked)}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <label htmlFor="termsCheckbox" className="ml-2 text-gray-700">
                    I accept the Terms and Conditions
                  </label>
                </div>
                <div className="flex justify-end space-x-3">
                  <button
                    onClick={() => setShowPopup(false)}
                    className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 transition duration-200"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={onSubmit}
                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition duration-200"
                  >
                    Agree & Submit
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <ApplicationSuccess />
      )}
    </>
  );
};

export default MentorProfileForm;
